// TicketNavigator.js
import React, { useState } from 'react';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';

const TicketNavigator = ({ tickets, currentNumber, setNumber }) => {
  const [currentTicketIndex, setCurrentTicketIndex] = useState(Number(currentNumber || 0));
  const allNumbers = tickets.map(item => +item);

  const goToPreviousTicket = () => {
    setCurrentTicketIndex((prevIndex) => {
      const newIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
      setNumber(allNumbers[newIndex]);  // Actualiza el número de ticket activo
      return newIndex;
    });
  };

  const goToNextTicket = () => {
    setCurrentTicketIndex((prevIndex) => {
      const newIndex = prevIndex < allNumbers.length - 1 ? prevIndex + 1 : prevIndex;
      setNumber(allNumbers[newIndex]);  // Actualiza el número de ticket activo
      return newIndex;
    });
  };

  const formattedTicketNumber = () => (currentNumber < 10 ? `0${currentNumber}` : `${currentNumber}`);
  
  return (
    <div className="ticket-navigator flex gap-2 items-center">
      <div>
        <button
          onClick={goToPreviousTicket}
          disabled={currentTicketIndex === 0}
          className={`p-1 rounded-full cursor-pointer ${
            currentTicketIndex === 0 ? 'bg-gray-300 opacity-50 cursor-not-allowed' : 'bg-gray-300 hover:bg-gray-500'
          }`}
        >
          <FiArrowLeft />
        </button>
      </div>

      <span style={{ color: "red", fontSize: "18px" }} className="font-bold">
        Ticket N° {formattedTicketNumber()}
      </span>

      <div>
        <button
          onClick={goToNextTicket}
          disabled={currentTicketIndex === tickets.length - 1}
          className={`p-1 rounded-full cursor-pointer ${
            currentTicketIndex === tickets.length - 1 ? 'bg-gray-300 opacity-50 cursor-not-allowed' : 'bg-gray-300 hover:bg-gray-500'
          }`}
        >
          <FiArrowRight />
        </button>
      </div>
    </div>
  );
};

export default TicketNavigator;
